import { PayloadAction, createSlice } from "@reduxjs/toolkit";

export type CameraFacingMode = "user" | "environment";

export interface CameraState {
  facingMode: CameraFacingMode;
}

const initialState: CameraState = {
  facingMode: "environment",
};

export const CameraSlice = createSlice({
  name: "camera",
  initialState,
  reducers: {
    setFacingMode: (state, action: PayloadAction<CameraFacingMode>) => {
      state.facingMode = action.payload;
    },
  },
});

export const { setFacingMode } = CameraSlice.actions;
